import React, { FC, useEffect } from 'react';
import classNames from 'classnames';
import { RouteComponentProps } from 'react-router';
import styles from './assets/seance-edit-screen.module.scss';
import Loader from 'src/components/Loader';
import AdminLayout from 'src/components/layout/RoleLayout';
import Form from '../../components/SeanceForm';
import { ISeance } from 'src/types/seance';

//import { asyncCreateFilesSeance } from 'src/store/actions/seance-actions';
import Breadcrumbs from 'src/components/Breadcrumbs';
import { routes } from 'src/navigation';

export interface StateProps {
    seance: ISeance | null;
    inProgress: boolean;
    files: any;
}

export interface DispatchProps {
    getData: (id: string | number) => void;
    // getFiles: (id: string | number) => void;

    // removeFile: (id: string | number) => void;
}

interface RouteParams {
    id: string;
}

export interface OwnProps extends RouteComponentProps<RouteParams> {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const SeanceEditScreen: FC<Props> = (props: Props) => {
    const {
        seance,
        match: {
            params: { id },
        },
        //       getFiles,
        files,

        //     removeFile,
        getData,
        inProgress,
    } = props;

    useEffect(() => {
        if (!seance || `${seance.id}` !== `${id}`) {
            getData(id);
            //       getFiles(id);
        }
        // eslint-disable-next-line
    }, [getData]);

    const handeAdd = async (files: any) => {
        //    await asyncCreateFilesSeance(id, files, dispatch);
    };
    const handeRemove = (fileId: string | number) => {
        // removeFile(fileId);
    };

    return (
        <AdminLayout>
            <Breadcrumbs
                items={[
                    { name: 'SESSIONS', path: routes.SEANCES_LIST },
                    { name: `EDIT ${seance?.id}`, path: '' },
                ]}
            />
            <div className={classNames(styles.editWrap)}>
                {inProgress ? <Loader /> : !seance ? <div></div> : null}
                <Form
                    files={files ? files : []}
                    setFiles={handeAdd}
                    removeFile={(id) => handeRemove(id)}
                    initialValues={{ ...seance }}
                />
            </div>
        </AdminLayout>
    );
};

export default SeanceEditScreen;
